module.exports = __webpack_public_path__ + "static/media/it-manager_320.501e6b12.jpg";